import styled from "styled-components";

export const LeftSideSingleChat = styled.div`
  cursor: pointer;
  min-height: 72px;
  background: ${props => props.theme?.palette?.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'};
  padding: 14px 18px;
  color: ${props => props.theme?.palette?.mode === 'dark' ? 'white' : '#1a1a1a'};
  border-bottom: 1px solid ${props => props.theme?.palette?.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.08)'};
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &:hover {
    background: ${props => props.theme?.palette?.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)'};
    transform: translateX(4px);
    border-left: 3px solid ${props => props.theme?.palette?.primary?.main || '#d44401'};
    padding-left: 15px;
  }

  &:active {
    transform: translateX(2px);
  }
`;

export const LeftSideSingleChatUsername = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
  letter-spacing: 0.01em;
`;

export const LeftSideSingleChatMessageMine = styled.span`
  color: ${props => props.theme?.palette?.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)'};
  font-weight: 500;
`;

export const LeftSideSingleChatMessage = styled.div`
  font-size: 13px;
  color: ${props => props.theme?.palette?.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'};
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LeftSideChatsTopNotice = styled.div`
  text-align: center;
  color: #b4b2b2;
  font-size: smaller;
  margin: 5px auto;
`;
